import { inject, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { Observable, tap, withLatestFrom } from 'rxjs';

import { updatingMultiUserRecentActivities } from 'app/state/multi-user-preferences/multi-user-preferences.actions';
import { selectAppModeIfDefined } from 'app/state/settings/settings.selectors';
import { updatingUserRecentActivities } from 'app/state/user-session/user-session.actions';

import { done, ProgressState, running } from '../../models';
import { Activity } from './models';

export interface ActivitySelectorState {
    activities: Activity[];
    filteredActivities: Activity[];
    initialization: ProgressState;
}

const initialState: ActivitySelectorState = {
    activities: [],
    filteredActivities: [],
    initialization: running(),
};

@Injectable()
export class ActivitySelectorStore extends ComponentStore<ActivitySelectorState> {
    private store = inject(Store);

    activities$ = this.select((state) => state.activities);
    filteredActivities$ = this.select((state) => state.filteredActivities);
    initializationFinished$ = this.select((state) => state.initialization.done);

    constructor() {
        super(initialState);
    }

    updateActivities = this.updater((state, activities: Activity[]) => ({ ...state, activities }));

    updateFilteredActivities = this.updater((state, filteredActivities: Activity[]) => ({
        ...state,
        filteredActivities,
        initialization: done(),
    }));

    onActivitySelected = this.effect((activity$: Observable<Activity>) =>
        activity$.pipe(
            withLatestFrom(this.store.pipe(selectAppModeIfDefined)),
            tap(([activity, appMode]) => {
                if (appMode === 'multi-user') {
                    this.store.dispatch(
                        updatingMultiUserRecentActivities({ activityNumber: activity.number }),
                    );
                } else {
                    this.store.dispatch(updatingUserRecentActivities({ activityNumber: activity.number }));
                }
            }),
        ),
    );
}
